import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import exact from 'prop-types-exact'
import { removeModal } from './modalActions'
import RedirectModal from './RedirectModal'
import NotificationModal from './NotificationModal'
import ProfileInformationModal from './ProfileInformationModal'
import ProfileSaveModal from './ProfileSaveModal'
import UrlCopyModal from './UrlCopyModal'
import { logWarning } from '../../sentry'
import { selectModalsQueueHead } from '../../selectors/modalSelectors'

export const NOTIFICATION_MODAL = 'notificationModal'
export const REDIRECT_MODAL = 'redirectModal'
export const TEMPORARY_PROFILE_MODAL = 'temporaryProfileModal'
export const TEMPORARY_PROFILE_SAVE_MODAL = 'temporaryProfileSaveModal'
export const LOGIN_REQUIRED_MODAL = 'loginRequiredModal'
export const URL_COPY_MODAL = 'urlCopyModal'

@connect((state) => {
  let activeModal = selectModalsQueueHead(state)
  let activeModalData = null

  // Map some data based on the active modal type
  if (activeModal) {
    switch (activeModal.get('id')) {
      case REDIRECT_MODAL: {
        const itemId = activeModal.get('data').get('itemId')
        const item = state.items.items.get(itemId)
        if (item) {
          const link = state.items.items.get(itemId).get('link')
          activeModalData = Map({
            redirectUrl: link,
          })
        } else {
          logWarning('Invalid item id: ' + itemId)
          activeModal = null
        }
        break
      }
      case NOTIFICATION_MODAL:
        activeModalData = Map({
          message: activeModal.get('data').get('message'),
          title: activeModal.get('data').get('title'),
        })
        break

      default:
        activeModalData = activeModal.get('data')
    }
  }

  return {
    activeModal: activeModal,
    activeModalData: activeModalData,
  }
})

export default class Modals extends Component {

  static propTypes = exact({
    activeModal: ImmutablePropTypes.map,
    activeModalData: ImmutablePropTypes.map,
    dispatch: PropTypes.func.isRequired,
  })

  constructor() {
    super()

    this.state = {
      activeModal: null,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeModal !== this.props.activeModal) {
      this.setState({
        activeModal: this.getActiveModal(),
      })
    }
  }

  getActiveModal() {
    const { dispatch, activeModal, activeModalData } = this.props

    if (activeModal) {
      switch (activeModal.get('id')) {
        case REDIRECT_MODAL:
          return (
            <RedirectModal
              onClose={ this.handleModalClose }
              redirectUrl={ activeModalData.get('redirectUrl') }
            />
          )

        case NOTIFICATION_MODAL:
          return (
            <NotificationModal
              onClose={ this.handleModalClose }
              message={ activeModalData.get('message') }
              title={ activeModalData.get('title') }
            />
          )

        case TEMPORARY_PROFILE_MODAL:
          return (
            <ProfileInformationModal
              onClose={ this.handleModalClose }
              dispatch={ dispatch }
            />
          )

        case TEMPORARY_PROFILE_SAVE_MODAL:
          return (
            <ProfileSaveModal
              onClose={ this.handleModalClose }
              dispatch={ dispatch }
            />
          )

        case URL_COPY_MODAL:
          return (
            <UrlCopyModal
              onClose={ this.handleModalClose }
              url={ activeModalData.get('url') }
              title={ activeModalData.get('title') }
            />
          )

      }
    }

    return null
  }

  handleModalClose = (modalId) => {
    this.props.dispatch(removeModal(modalId))
  }

  render() {
    return this.state.activeModal
  }
}
